import { render, staticRenderFns } from "./premium-features-list.vue?vue&type=template&id=7d5b0d91&"
import script from "./premium-features-list.vue?vue&type=script&lang=js&"
export * from "./premium-features-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports